import React from "react";
import "./pvaTestReport.css";
import { useSelector } from "react-redux";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import ArrayTable from "./arrTab_com/arrTable";
import { panels } from "../../data/staticData";
import { INSPECTOR_LIST } from "../../data/inspector_data";

export default function PVATestReport() {
  const { invertersList, selectedPanel } = useSelector(
    (state) => state.pva_test
  );

  const panel = panels.find((item) => item.name === selectedPanel);

  const { selectedInspectorId, formData } = useSelector(
    (state) => state.ins_info
  );

  const selectedInspector =
    INSPECTOR_LIST.find((ins) => ins.id === selectedInspectorId) || null;

  return (
    <div className="pv_atest">
      <img className="report_Logo" src="../images/uEnergy.png" alt="Logo"></img>
      <h1 className="report_title">Solar PV Array Test Report</h1>

      {/* Basic_info_section */}
      <ul className="table_sv">
        <li className="table_col">
          <h1>PV System Verification Certificate</h1>
          <div className="sv_type">
            <h2>
              {formData?.verificationType === "Initial" ? (
                <CheckBoxIcon fontSize="small" color="primary" />
              ) : (
                <CheckBoxOutlineBlankIcon fontSize="small" />
              )}
              &nbsp;Initial Verification
            </h2>

            <h2>
              {formData?.verificationType === "Periodic" ? (
                <CheckBoxIcon fontSize="small" color="primary" />
              ) : (
                <CheckBoxOutlineBlankIcon fontSize="small" />
              )}
              &nbsp;Periodic Verification
            </h2>
          </div>
        </li>
      </ul>

      {/* Basic_info_section */}
      <ul className="table_sec1">
        <li className="table_col">
          <h1>Reference</h1>
          <h2>{formData?.manualRef}</h2>
          <h1 className="dateTab">Date</h1>
          <h2>{formData?.date}</h2>
        </li>
      </ul>

      <ul className="table_sec1">
        <li className="table_col">
          <h1>Installation Address</h1>
          <h2>{formData?.installationAddress}</h2>
        </li>
        <li className="table_col">
          <h1>Description of work under test</h1>
          <h2>{formData?.description}</h2>
        </li>
        <li className="table_col">
          <h1>Test Instruments</h1>
          <h2>{formData?.testInstrument}</h2>
        </li>
        <li className="table_col">
          <h1>Inspector</h1>
          <h2>{selectedInspector?.name}</h2>
        </li>
      </ul>

      {invertersList?.map((item, i) => (
        <div key={i}>
          <ul className="inv_info" style={{ margin: "10px 0px" }}>
            <h6>Inerter(INV{i + 1})</h6>
            <div className="sub_info">
              <div className="info_list">
                <h4>Make and Model</h4>
                <h5>{item?.name} </h5>
              </div>
              <div className="info_list">
                <h4>Serial number</h4>
                <h5>{item?.serialNo}</h5>
              </div>
            </div>
          </ul>
          <ArrayTable data={item} key={i} panel={panel} />
        </div>
      ))}

      <div className="comment">
        <p>
          <strong>Comment:</strong>{" "}
          {formData?.pvStringComment || "No comment yet."}
        </p>
      </div>
    </div>
  );
}
